var r="@hpstellar/core/list";export{r as listTestId};
